import { type EventWithSeatsAndTickets } from '#app/utils/providers/events.server.js'
import {
	BUILDINGS,
	COAST,
	ROADS_MAIN,
	ROADS_SERVICE,
	SEA,
	getVenuePinData,
} from '#app/domains/program/pure'

export function ProgramMap({ events }: { events: EventWithSeatsAndTickets[] }) {
	const pins = getVenuePinData(events)

	return (
		<svg
			className="pp-map-svg"
			viewBox="-15 -8 338 376"
			preserveAspectRatio="xMidYMid meet"
			role="img"
			aria-label="Kart over Vorrå-feltet med konsertlokale"
		>
			{/* land */}
			<rect x="-15" y="-8" width="338" height="376" fill="#eef3e2" rx="6" />
			{/* the sea (real shoreline) */}
			<path d={SEA} fill="#cfe4ee" />
			<path d={COAST} stroke="#a9cbdd" strokeWidth="1.5" fill="none" />
			{/* building footprints (real, from OSM) */}
			<path d={BUILDINGS} fill="#e5d9c3" stroke="#b7a88e" strokeWidth="0.6" />
			{/* roads (real geometry): service roads first, then main */}
			<path
				d={ROADS_SERVICE}
				stroke="#fffdf7"
				strokeWidth="4"
				fill="none"
				strokeLinecap="round"
			/>
			<path
				d={ROADS_MAIN}
				stroke="#fffdf7"
				strokeWidth="7"
				fill="none"
				strokeLinecap="round"
			/>
			{/* road name labels */}
			<text
				x="42"
				y="128"
				fontSize="8"
				fill="#6b5d4d"
				fontStyle="italic"
				fontFamily="Georgia, serif"
				transform="rotate(65 42 128)"
			>
				Vorråvegen
			</text>
			<text
				x="150"
				y="212"
				fontSize="8"
				fill="#6b5d4d"
				fontStyle="italic"
				fontFamily="Georgia, serif"
				transform="rotate(14 150 212)"
			>
				Liarvegen
			</text>
			{/* place labels */}
			<text
				x="115"
				y="272"
				fontSize="7.5"
				fill="#7ba3b8"
				fontStyle="italic"
				fontFamily="Georgia, serif"
			>
				Vorråstranda
			</text>
			<text
				x="154"
				y="320"
				textAnchor="middle"
				fontSize="10"
				fill="#8fb6c9"
				fontStyle="italic"
				letterSpacing="2"
				fontFamily="Georgia, serif"
			>
				Vorråvågen
			</text>
			{/* venue pins */}
			{pins.map((pin) => (
				<g key={pin.number}>
					<circle
						cx={pin.x}
						cy={pin.y}
						r="9"
						fill="#8c3b2e"
						stroke="#fdfaf3"
						strokeWidth="2"
					/>
					<text
						x={pin.x}
						y={pin.y + 3.2}
						textAnchor="middle"
						fontSize="10"
						fontWeight="bold"
						fill="#fdfaf3"
						fontFamily="Georgia, serif"
					>
						{pin.number}
					</text>
					<text
						x={pin.x + pin.ldx}
						y={pin.y + pin.ldy}
						textAnchor={pin.lanchor}
						fontSize="8"
						fill="#2a2118"
						fontFamily="Georgia, serif"
					>
						{pin.location}
					</text>
				</g>
			))}
			{/* compass */}
			<g transform="translate(272 28)">
				<circle r="12" fill="#fdfaf3" stroke="#b7a88e" strokeWidth="1.5" />
				<path d="M0 -8 L3.5 5 L0 2.5 L-3.5 5 Z" fill="#8c3b2e" />
				<text y="-14" textAnchor="middle" fontSize="8" fill="#2a2118">
					N
				</text>
			</g>
			{/* area label */}
			<text
				x="150"
				y="20"
				textAnchor="middle"
				fontSize="11"
				letterSpacing="3"
				fill="#6b5d4d"
				fontStyle="italic"
				fontFamily="Georgia, serif"
			>
				Vorrå-feltet
			</text>
		</svg>
	)
}
